import React from 'react';
import {useSelector} from 'react-redux';
import {Link, NavLink, useHistory} from 'react-router-dom';
import Avatar from 'antd/es/avatar';
import Dropdown from 'antd/es/dropdown';
import Menu from 'antd/es/menu';
import Icon from 'antd/es/icon';
import {client} from '../../apollo/apolloClient';
import {LOG_OUT} from '../../apollo/schema';
import {getUserAvatarUrl} from '../../redux/selectors/selectors';
import {getAvatarUrl} from '../../helpers/util';
import './Navbar.css';

const NavbarLoggedIn = () => {
  const {push} = useHistory();
  const avatarUrl = useSelector(getUserAvatarUrl);

  const redirectToMedBook = () => {
    push('/medbook/');
  };

  const redirectToProfile = () => {
    push('/profile/');
  };

  const signOut = () => {
    client.query({
      query: LOG_OUT,
    }).then(res => {
      if (!res.hasOwnProperty('erros')) {
        localStorage.clear();
        localStorage.setItem('logout-event', 'logout' + Math.random());
        window.location.href = '/';
      }
    });
  };

  const menu = (
      <Menu>
        <Menu.Item onClick={redirectToProfile}>Profile</Menu.Item>
        <Menu.Item onClick={signOut}>Sign out</Menu.Item>
      </Menu>
  );

  return (
      <div className="navbar navbar-shadow">
        <Link to={'/'} className="navbar-brand">
          <img
              className="navbar-logo"
              src={'https://assets-new.medcampus.io/assets/images/medcampus-logo.png'}
              alt={'MedCampus logo'}
          />
        </Link>
        <div className="rs-triggers">
          <button
              className="join-us mc-mr-5"
              onClick={redirectToMedBook}
          >medBook
          </button>
          <Dropdown overlay={menu} trigger={['click']}>
            <Avatar
                src={getAvatarUrl(avatarUrl)}
                size={28}
            />
          </Dropdown>
        </div>
        <div className={'collapse-wrapped'}>
          <div
              className={'collapse'}
              onClick={(e) => e.stopPropagation()}
          >
            <Icon
                className="close-navbar"
                type="close"

            />
            <ul className="navbar-nav">
              <li><NavLink to={'/challenges/'}>challenges</NavLink></li>
              <li><NavLink to={'/prepmed/'}>prepMed</NavLink></li>
              <li><NavLink to={'/medpixx/'}>medPixx</NavLink></li>
              <li><NavLink to={'/mvideos/'}>mVideos</NavLink></li>
              <li><NavLink to={'/mnotes/'}>mNotes</NavLink></li>
              {/* <li><NavLink to={'/playwin/'}>Play & Win</NavLink></li> */}
              <li><NavLink to={'/medpass/'}>medPass</NavLink></li>
            </ul>
          </div>
        </div>
      </div>
  );
};

export {NavbarLoggedIn};
